import { render, staticRenderFns } from "./CurrenciesAutoComplete.html?vue&type=template&id=2ed889d9&"
import script from "./CurrenciesAutoComplete.js?vue&type=script&lang=js&"
export * from "./CurrenciesAutoComplete.js?vue&type=script&lang=js&"
import style0 from "./CurrenciesAutoComplete.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VIcon,VImg,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VSelect,VTextField})
